import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  run_index(event) {
    $("#index-loader").show()
  }

  connect() {
    addEventListener("page:before-change", $("#index-loader").hide())
  }
}
